var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMagnetDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14873 18L5.0743 18C5.34739 18 5.56885 17.7785 5.56885 17.5055L5.56885 14.0744L0.654182 14.0744L0.654182 17.5055C0.654182 17.7785 0.875635 18 1.14873 18Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56891 8.34594C5.56891 7.4186 5.93309 6.54981 6.59431 5.89951C7.2554 5.24939 8.13364 4.89927 9.05879 4.91539C10.9182 4.94642 12.431 6.5143 12.431 8.41054L12.431 13.0854L17.3457 13.0854L17.3457 8.34593C17.3457 3.74406 13.6018 0.000177711 8.99994 0.000178113C4.39806 0.000178515 0.654184 3.74406 0.654184 8.34594L0.654184 13.0855L5.56891 13.0855L5.56891 8.34594Z",
    fill: "#424242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.431 17.5055C12.431 17.7785 12.6524 18 12.9255 18L16.8512 18C17.1242 18 17.3457 17.7785 17.3457 17.5055L17.3457 14.0744L12.431 14.0744L12.431 17.5055Z",
    fill: "#424242"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagnetDisabled);
export default __webpack_public_path__ + "static/media/icon-magnet-disabled.28c30414502b553cbb1491e69318d6ca.svg";
export { ForwardRef as ReactComponent };